import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, } from "react-router-dom";
// project imports
import NavigationScroll from './layout/NavigationScroll';
// routing
import Routes from './routes';
// defaultTheme
import themes from './themes';
import { lazy } from 'react';
import Loadable from './ui-component/Loadable';
const AuthLogin3 = Loadable(lazy(() => import('./views/pages/authentication/authentication3/Login3')));

// ==============================|| APP ||============================== //

const admin = JSON.parse(localStorage.getItem("userInfo"));
const App = () => {
    const customization = useSelector((state) => state.customization);
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <NavigationScroll>
                    {/* {!admin ? <AuthLogin3 /> : <Routes />} */}
                    <Routes />
                </NavigationScroll>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
